import {createActionGroup, props} from '@ngrx/store';
import {DraftJobChanges} from '../../models/draft-job-changes.model';
import {DraftJobChangesFilter} from '../../models/draft-job-changes-filter.model';
import {DraftJobChangesPageParams} from '../services/planning-draft-job-changes-http.service';
import {BatchModel} from '../../../batch/models/batch.model';
import {ProcessTrackingModel} from '../../../commons/models/process-tracking.model';

export const PlanningDraftJobChangesApiActions = createActionGroup({
  source: 'Planning Draft Job Changes API',
  events: {
    // Scan
    scanDraftJobChanges: props<{ projectId: string, draftId: string }>(),
    scanDraftJobChangesSuccess: props<{ batch: BatchModel }>(),
    scanDraftJobChangesFailure: props<{ error: any }>(),

    // Get page
    getDraftJobChangesPage: props<{ projectId: string, draftId: string, params: DraftJobChangesPageParams }>(),
    getDraftJobChangesPageSuccess: props<{ list: DraftJobChanges[], totalElements: number, page: number }>(),
    getDraftJobChangesPageFailure: props<{ error: any }>(),

    // Apply
    applyDraftJobChanges: props<{ projectId: string, draftId: string, filter: DraftJobChangesFilter }>(),
    applyDraftJobChangesSuccess: props<{ batch: BatchModel }>(),
    applyDraftJobChangesFailure: props<{ error: any }>(),

    // Dismiss
    dismissDraftJobChanges: props<{ projectId: string, draftId: string, filter: DraftJobChangesFilter }>(),
    dismissDraftJobChangesSuccess: props<{ filter: DraftJobChangesFilter }>(),
    dismissDraftJobChangesFailure: props<{ error: any }>(),

    // Process tracking
    getDraftJobChangesProcessTracking: props<{ projectId: string, draftId: string, params?: any }>(),
    getDraftJobChangesProcessTrackingSuccess: props<{ list: ProcessTrackingModel[] }>(),
    getDraftJobChangesProcessTrackingFailure: props<{ error: any }>(),

    // Local UI state
    setSelectedIds: props<{ selectedIds: string[] }>(),
    setSelectAllMatching: props<{ selectAllMatching: boolean }>(),
    setFilters: props<{ filters: DraftJobChangesFilter }>(),
    clearStore: props<{ force?: boolean }>()
  }
});
